import React from 'react';
import StyledSelect from '../../components/StyledSelect';
import { styles, labelStyle } from './trainAgentStyles';

export function TrainAgentSelectors({ vm }) {
  const {
    clients,
    selectedClientId,
    setSelectedClientId,
    bots,
    selectedBotId,
    setSelectedBotId,
    loading
  } = vm;

  return (
    <div style={styles.row}>
      <div style={{ flex: 1, marginRight: '16px' }}>
        <label style={labelStyle}>Cliente</label>
        <StyledSelect
          value={selectedClientId}
          onChange={setSelectedClientId}
          options={[
            { value: '', label: '— Selecione o cliente —' },
            ...clients.map((c) => ({ value: c.id || c._id, label: c.name }))
          ]}
          placeholder="— Selecione o cliente —"
        />
      </div>
      <div style={{ flex: 1 }}>
        <label style={labelStyle}>Bot (agente)</label>
        <StyledSelect
          value={selectedBotId}
          onChange={setSelectedBotId}
          options={[
            { value: '', label: '— Selecione o bot —' },
            ...bots.map((b) => ({ value: b.id, label: `${b.name} (${b.id})` }))
          ]}
          placeholder="— Selecione o bot —"
          disabled={loading || !bots.length}
        />
      </div>
    </div>
  );
}
